import { render, staticRenderFns } from "./portal_main.vue?vue&type=template&id=fe29a3c6&scoped=true"
import script from "./portal_main.vue?vue&type=script&lang=ts"
export * from "./portal_main.vue?vue&type=script&lang=ts"
import style0 from "./portal_main.vue?vue&type=style&index=0&id=fe29a3c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe29a3c6",
  null
  
)

export default component.exports